var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgKey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.9752 7.96002C16.9752 8.5123 16.5297 8.96002 15.9802 8.96002C15.4306 8.96002 14.9851 8.5123 14.9851 7.96002C14.9851 7.40773 15.4306 6.96002 15.9802 6.96002C16.5297 6.96002 16.9752 7.40773 16.9752 7.96002ZM14.7861 4C11.9091 4 9.57214 6.34863 9.57214 9.24C9.57214 9.54977 9.61208 9.8483 9.66007 10.1232C9.67425 10.2044 9.64833 10.2749 9.60497 10.3185L4.64115 15.3071C4.23063 15.7197 4 16.2793 4 16.8627V18.6C4 19.3732 4.62368 20 5.39304 20H7.38309C8.15244 20 8.77612 19.3732 8.77612 18.6V17.6H10.1692C10.7187 17.6 11.1642 17.1523 11.1642 16.6V15.2H12.5572C13.0944 15.2 13.5323 14.7722 13.5516 14.237C13.947 14.3392 14.3639 14.4 14.7861 14.4C17.663 14.4 20 12.0514 20 9.16C20 6.25509 17.6494 4 14.7861 4ZM10.7662 9.24C10.7662 7.01138 12.5685 5.2 14.7861 5.2C17.0172 5.2 18.806 6.94492 18.806 9.16C18.806 11.3886 17.0036 13.2 14.7861 13.2C14.2453 13.2 13.6887 13.0631 13.1904 12.8485C13.0059 12.769 12.7941 12.7881 12.6266 12.8991C12.4591 13.0102 12.3582 13.1983 12.3582 13.4V14H10.9652C10.4157 14 9.97016 14.4477 9.97016 15V16.4H8.57712C8.02758 16.4 7.58209 16.8477 7.58209 17.4V18.6C7.58209 18.7105 7.49299 18.8 7.38309 18.8H5.39304C5.28313 18.8 5.19403 18.7105 5.19403 18.6V16.8627C5.19403 16.5975 5.29886 16.3432 5.48547 16.1556L10.4493 11.167C10.7823 10.8323 10.914 10.3616 10.8361 9.91585C10.7934 9.67108 10.7662 9.44992 10.7662 9.24Z",
    fill: "#414548"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKey);
export default __webpack_public_path__ + "static/media/Key.5958acb2a253b0c264d1e039a5eb08b1.svg";
export { ForwardRef as ReactComponent };